import React from 'react';
import { motion } from 'framer-motion';
import { YoutubeIcon, PlayIcon } from 'lucide-react';
const VideoSection = () => {
  return <section className="relative py-16 md:py-20 overflow-hidden" data-id="element-287">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-288">
        <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg" data-id="element-289">
          <defs data-id="element-290">
            <pattern id="wave-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse" data-id="element-291">
              <path d="M0 50 Q 25 30, 50 50 T 100 50" stroke="#1e40af" strokeWidth="0.5" fill="none" data-id="element-292" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#wave-pattern)" data-id="element-293" />
        </svg>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-294">
        <motion.div className="text-center mb-10 md:mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-295">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-900 mb-3" data-id="element-296">
            Watch IGS on YouTube
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-4" data-id="element-297"></div>
          <p className="text-gray-700 max-w-2xl mx-auto text-sm md:text-base px-4" data-id="element-298">
            Explore our official YouTube channel for school events, student
            achievements, campus tours, and much more.
          </p>
        </motion.div>
        <motion.div className="max-w-5xl mx-auto" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-299">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center" data-id="element-300">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-2xl p-6 md:p-8 border border-blue-100" data-id="element-301">
              <div className="flex items-center justify-center mb-6" data-id="element-302">
                <div className="bg-red-600 rounded-full p-4" data-id="element-303">
                  <YoutubeIcon className="h-10 w-10 md:h-12 md:w-12 text-white" data-id="element-304" />
                </div>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-blue-900 text-center mb-4" data-id="element-305">
                Isonyin Grammar School
              </h3>
              <p className="text-gray-700 text-center mb-6 text-sm md:text-base" data-id="element-306">
                Official YouTube Channel
              </p>
              <div className="space-y-4" data-id="element-307">
                <div className="bg-blue-50 rounded-lg p-4 text-center" data-id="element-308">
                  <p className="text-sm text-gray-600 mb-1" data-id="element-309">
                    Latest Videos & Updates
                  </p>
                  <p className="text-xl md:text-2xl font-bold text-blue-900" data-id="element-310">
                    School Events & More
                  </p>
                </div>
                <a href="https://www.youtube.com/@IsonyinGrammarSchool" target="_blank" rel="noopener noreferrer" className="block w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 md:py-4 px-6 rounded-lg transition-colors text-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all text-sm md:text-base" data-id="element-311">
                  <div className="flex items-center justify-center" data-id="element-312">
                    <YoutubeIcon className="h-5 w-5 mr-2" data-id="element-313" />
                    Visit Our YouTube Channel
                  </div>
                </a>
                <a href="https://www.youtube.com/@IsonyinGrammarSchool?sub_confirmation=1" target="_blank" rel="noopener noreferrer" className="block w-full bg-blue-700 hover:bg-blue-800 text-white font-medium py-3 px-6 rounded-lg transition-colors text-center text-sm md:text-base" data-id="element-314">
                  Subscribe for Updates
                </a>
              </div>
            </div>
            <div className="space-y-4 md:space-y-6" data-id="element-315">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-5 md:p-6 border border-blue-100" data-id="element-316">
                <div className="flex items-start" data-id="element-317">
                  <div className="bg-yellow-500 rounded-full p-2 mr-4 flex-shrink-0" data-id="element-318">
                    <PlayIcon className="h-5 w-5 md:h-6 md:w-6 text-blue-900" data-id="element-319" />
                  </div>
                  <div data-id="element-320">
                    <h4 className="font-bold text-blue-900 mb-2 text-sm md:text-base" data-id="element-321">
                      School Events & Celebrations
                    </h4>
                    <p className="text-gray-700 text-xs md:text-sm" data-id="element-322">
                      Watch highlights from our inter-house sports, cultural
                      days, and graduation ceremonies.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-5 md:p-6 border border-blue-100" data-id="element-323">
                <div className="flex items-start" data-id="element-324">
                  <div className="bg-yellow-500 rounded-full p-2 mr-4 flex-shrink-0" data-id="element-325">
                    <PlayIcon className="h-5 w-5 md:h-6 md:w-6 text-blue-900" data-id="element-326" />
                  </div>
                  <div data-id="element-327">
                    <h4 className="font-bold text-blue-900 mb-2 text-sm md:text-base" data-id="element-328">
                      Virtual Campus Tours
                    </h4>
                    <p className="text-gray-700 text-xs md:text-sm" data-id="element-329">
                      Take a virtual walk through our campus and explore our
                      facilities.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl shadow-lg p-5 md:p-6 border border-blue-100" data-id="element-330">
                <div className="flex items-start" data-id="element-331">
                  <div className="bg-yellow-500 rounded-full p-2 mr-4 flex-shrink-0" data-id="element-332">
                    <PlayIcon className="h-5 w-5 md:h-6 md:w-6 text-blue-900" data-id="element-333" />
                  </div>
                  <div data-id="element-334">
                    <h4 className="font-bold text-blue-900 mb-2 text-sm md:text-base" data-id="element-335">
                      Student Achievements
                    </h4>
                    <p className="text-gray-700 text-xs md:text-sm" data-id="element-336">
                      Celebrate the accomplishments of our students in
                      academics, sports, and activities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default VideoSection;